import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Download from "./components/download/Download";
import Profile from "./components/profile/Profile";
import Nda from "./components/Nda";

function Content() {
  const location = useLocation();

  return (
    <div className=" bg-slate-200 items-center p-4 min-h-screen">
      {location.pathname !== "/nda" && <Profile />}
      {location.pathname !== "/nda" && <Download />}
      <Routes>
        <Route path="/nda" element={<Nda />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Content />
    </Router>
  );
}

export default App;
